<div #container class="media-collection" >
  <!--openseadragon content will be injected inside-->
</div>


<!--overlay con la controladora de la galeria-->
<app-collection-controller [collection]="collection" (indexSelected)="collectionIndexOnChanged($event)" ></app-collection-controller>
